export default {
    home: "Otthon",
    order: {
        submit: "Rendelés áttekintése"
    },
    tunnel: {
        loginVerification: "Bejelentkezés ellenőrzése",
        addressVerification: "Cím ellenőrzése"
    },
    catalog: "Katalógus",
    all: "Minden",
    return: {
        return: "Visszatérés"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Rendelés a következő nevében",
    approvals: "Jóváhagyások",
    delegate: "küldöttek",
    employees: "Alkalmazottaim",
}